module.exports = __webpack_public_path__ + "img/book.0ab22542.png";